import React, { useState } from 'react';
import { motion, Reorder } from 'framer-motion';
import { ArrowRight, GripVertical } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const initialItems = [{
  id: 'direction',
  label: 'Clear direction',
  icon: '🧭'
}, {
  id: 'optimism',
  label: 'More optimism',
  icon: '☀️'
}, {
  id: 'connection',
  label: 'Stronger connection',
  icon: '🤝'
}, {
  id: 'momentum',
  label: 'Proof that momentum is real',
  icon: '🚀'
}, {
  id: 'pride',
  label: 'A reason to feel proud',
  icon: '🏆'
}];
export const Screen3Ranking = ({
  onNext
}: Props) => {
  const [items, setItems] = useState(initialItems);
  const [moved, setMoved] = useState(false);
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-338">
      <div className="absolute inset-0 bg-gradient-to-br from-red-950/30 via-slate-950 to-slate-950" data-id="element-339" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-340">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-red-500 font-semibold mb-4" data-id="element-341">
          03 — Prioritize
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl font-bold text-white leading-tight mb-2" data-id="element-342">
          What do your colleagues need{' '}
          <span className="text-red-500" data-id="element-343">most</span> right now?
        </motion.h2>
        <p className="text-sm text-slate-400 mb-6" data-id="element-344">
          Drag to rank — top = most important.
        </p>

        <Reorder.Group axis="y" values={items} onReorder={newItems => {
        setItems(newItems);
        setMoved(true);
      }} className="flex-1 space-y-3" data-id="element-345">
          {items.map((item, index) => <Reorder.Item key={item.id} value={item} className="cursor-grab active:cursor-grabbing" whileDrag={{
          scale: 1.05,
          boxShadow: '0 20px 40px rgba(220,38,38,0.3)'
        }} data-id="element-346">
              <div className="bg-slate-900/80 backdrop-blur-md border border-slate-800 rounded-2xl p-4 flex items-center space-x-3" data-id="element-347">
                <span className="text-xs font-bold text-red-500 w-5" data-id="element-348">
                  {index + 1}
                </span>
                <span className="text-2xl" data-id="element-349">{item.icon}</span>
                <span className="flex-1 text-white font-medium" data-id="element-350">
                  {item.label}
                </span>
                <GripVertical className="w-4 h-4 text-slate-600" data-id="element-351" />
              </div>
            </Reorder.Item>)}
        </Reorder.Group>

        <button onClick={onNext} disabled={!moved} className="mt-6 w-full bg-red-600 hover:bg-red-500 disabled:bg-slate-800 disabled:text-slate-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-352">
          <span data-id="element-353">Lock in my ranking</span>
          <ArrowRight className="w-5 h-5" data-id="element-354" />
        </button>
      </div>
    </div>;
};